// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1169":"da4acb70","1547":"c655211c"}[chunkId] + ".css";
};